import React, { useState, useEffect } from 'react';
import { makeStyles, Grid, Typography } from '@material-ui/core';
import { DialogContentText } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslation } from 'react-i18next';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import clsx from 'clsx';
import { fromNewDateFormatToDDMMYYYYHHmmssSlash } from '../../Helpers/dateHelper';

export default function ZoneDivisionPopup(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [zoneDivisions, setZoneDivisions] = useState([]);
    const [zoneOrderLine, setZoneOrderLine] = useState(null);
    const [value, setValue] = useState(0);

    useEffect(() => {
        if (props.zoneDivisionsOrderLineId !== zoneOrderLine) {
            setZoneDivisions(props.zoneDivisions.filter(x => x.newEntry === false));
            setZoneOrderLine(props.zoneDivisionsOrderLineId);
            setValue(props.zoneDivisions.filter(x => x.newEntry === false).length - 1);
        }
    }, [props.zoneDivisionsOrderLineId]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    return (
        <Dialog className={classes.dialogContainer}
            open={props.popupOpen}
            onClose={() => props.openZoneDivisionPopup(false)}
            aria-labelledby="draggable-dialog-title"
            fullWidth
            maxWidth="xl"
        >
            <DialogTitle className={classes.dialogTitle} id="draggable-dialog-title">
                {t('Zonale verdeling')}
            </DialogTitle>
            <DialogContent >
                <DialogContentText className={classes.dialogContext}>
                    {props.hasZoneDivisions ?
                        <React.Fragment>
                            {
                                props.zoneDivisions[value].insertedOn !== null && props.zoneDivisions[value].insertedOn !== undefined ?
                                    <Box className={classes.informationContainer}>
                                        <Box className={classes.informationBlock} component={Paper}>
                                            <Typography className={classes.darkendBackground} variant="h6">{t('Aangemaakt door')}</Typography>
                                            <div className={classes.divider}></div>
                                            <Typography className={classes.wrapText} variant="h6">{props.zoneDivisions[value].userName}</Typography>
                                        </Box>
                                        <Box className={classes.informationBlock} component={Paper}>
                                            <Typography className={classes.darkendBackground} variant="h6" component="h6">{t('Aangemaakt op')}</Typography>
                                            <div className={classes.divider}></div>
                                            <Typography className={classes.wrapText} variant="h6" component="h6">{fromNewDateFormatToDDMMYYYYHHmmssSlash(props.zoneDivisions[value].insertedOn)}</Typography>
                                        </Box>
                                    </Box> : <React.Fragment></React.Fragment>}
                            <AppBar position="static" className={classes.appBar}>
                                <Tabs value={value} onChange={handleChange}>
                                    {zoneDivisions.map((zd, zdKey) => (
                                        <Tab key={"zdKey_" + zdKey} label={zd.entry} className={clsx({ [classes.activeTab]: value === zd.entry - 1, [classes.notActiveTab]: value !== zd.entry - 1 })} />
                                    ))}
                                </Tabs>
                            </AppBar>
                            {zoneDivisions.map((zde, zoneIndex) => (
                                <TabPanel value={value} key={'99_zoneDivisions_' + zoneIndex}>
                                    <Grid container spacing={3} className={classes.grid}>
                                        <TableContainer className={classes.paper}>
                                            <Table className={classes.table} aria-label="customized table">
                                                <TableBody>
                                                    <TableRow key={"zone_" + zde.entry} className={classes.row} style={{ background: '#E6E8FE' }}>
                                                        <TableCell className={classes.boldNameCell}>
                                                            {t('zone')}
                                                        </TableCell>
                                                        {zde.zoneDivisions.map((zd, anotherIndex) => (
                                                            <TableCell key={"109_TableCell_" + anotherIndex} className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                                <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                    {zd.zone}
                                                                </span>
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                    <TableRow key={"temperature_" + zde.entry} className={classes.row}>
                                                        <TableCell className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                            {t('temperature')}{t('(°C)')}
                                                        </TableCell>
                                                        {zde.zoneDivisions.map((zd, tempZoneIndex) => (
                                                            <TableCell key={"121_zd_" + tempZoneIndex} className={classes.nameCell}>
                                                                {zd.temperature}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                    <TableRow key={"length_" + zde.entry} className={classes.row}>
                                                        <TableCell className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                            {t('length')}{t('(mm)')}
                                                        </TableCell>
                                                        {zde.zoneDivisions.map((zd, anotherIndex) => (
                                                            <TableCell key={"131_zd_" + anotherIndex} className={classes.nameCell}>
                                                                {zd.length}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                    <TableRow key={"width_" + zde.entry} className={classes.row}>
                                                        <TableCell className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                            {t('width')}{t('(mm)')}
                                                        </TableCell>
                                                        {zde.zoneDivisions.map((zd, zoneDivIndex) => (
                                                            <TableCell key={"141_zd_" + zoneDivIndex} className={classes.nameCell}>
                                                                {zd.width}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                    <TableRow key={"weight_" + zde.entry} className={classes.row}>
                                                        <TableCell className={classes.boldNameCell} style={{ background: '#E6E8FE' }}>
                                                            {t('weight')}{t('(gr/m²)')}
                                                        </TableCell>
                                                        {zde.zoneDivisions.map((zd, zdeIndex) => (
                                                            <TableCell key={"151_zd_" + zdeIndex} className={classes.nameCell}>
                                                                {zd.weight}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </TabPanel>
                            ))}
                        </React.Fragment> : <React.Fragment>{t('Geen zonale verdeling ingegeven')}</React.Fragment>
                    }
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
}


const useStyles = makeStyles(() => ({

    dialogContainer: {
        maxWidth: "1200px !important",
        maxHeight: "1000px !important",
        margin: "auto"
    },
    dialogTitle: {
        color: "#000000",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        '& h2': {
            fontSize: "32px !important",
        },
        paddingTop: "20px",
        cursor: 'move'
    },
    dialogContext: {
        color: "#000000",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        textAlign: "center",
        paddingBottom: "20px"
    }, 
    nameCell: {
        border: "1px solid #ddd",
        textAlign: "center"
    },

    row: {
        border: "1px solid #ddd"
    },
    boldNameCell: {
        border: "1px solid #ddd",
        fontWeight: "bold"
    },
    appBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",
        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
            width: "80px !important"
        },
        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "97%",
        overflow: "visible"

    },
    activeTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    notActiveTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    paper: {
        width: "1200px !important"
    },
    informationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
    },
    informationBlock: {
        display: 'flex',
        flexDirection: 'column',
        borderRight: '1px solid #e3e0de',
        borderRadius: '5px',
    },
    divider: {
        height: '1px',
        width: '100%',
        backgroundColor: '#e3e0de',
    },
    darkendBackground: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        backgroundColor: "rgb(230, 232, 254)",
        padding: '10px',
    },
    wrapText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        wordWrap: 'break-word',
        padding: '10px',
    },
}));
